import { useQuery } from '@apollo/client';
import { CREDIT_USED, CURRENT_SUBSCRIPTION } from '@repo-sapiens/graphql';
import { UserContext } from '../context';
import { useContext } from 'react';
import { SubscriptionResponse } from '../types';

export const useSubscriptionPlan = () => {
  // throw error if not under UserContext provider
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useSubscription must be used within a UserProvider');
  }

  const { data: subscriptionData, loading } =
    useQuery<SubscriptionResponse>(CURRENT_SUBSCRIPTION);

  const { data: creditUsedData, loading: creditUsedLoading } = useQuery<{
    creditUsed: number;
  }>(CREDIT_USED);

  const isTrial = subscriptionData?.currentSubscription?.isTrial || false;
  const isFree = subscriptionData?.currentSubscription?.plan === 'free';

  return {
    subscription: subscriptionData?.currentSubscription,
    loading: loading || creditUsedLoading,
    isTrial,
    //plan: subscriptionData?.currentSubscription?.plan || "free",
    isFree,
    expireIn: subscriptionData?.currentSubscription?.endAt
      ? new Date(subscriptionData?.currentSubscription?.endAt)
      : undefined,
    startAt: context.state?.firstSubscriptionAt,
    billingCycle: subscriptionData?.currentSubscription?.billingCycle,
    vipUser: context.state?.vipUser,
    stripeCustomerId: context.state?.stripeCustomerId,
    creditBalance: isFree && !isTrial ? creditUsedData?.creditUsed : 0,
    cancelAt: subscriptionData?.currentSubscription?.canceledAt,
  };
};
